import * as React from 'react';
import { get as getPartners } from '../../services/partner';
import { get as getDatabases, IDatabaseBase } from '../../services/database';
import { defineMessages, FormattedMessage, injectIntl, InjectedIntlProps } from 'react-intl';
import { Link } from 'react-router-dom';
import { DATABASE_CREATE_PATH } from '../../constants';
import { PropagateLoader } from 'react-spinners';
import { useEffect } from 'react';

interface IDatabaseSelectProps {
    defaultMessage: string;
    canCreate: boolean;
    noDatabasesMessage: string;
    onChange: (value: string) => void;
    currentModalId: string;
    errorMessage: any;
    hidePartnerDatabases?: boolean;
    selectedDatabaseName?: string | null;
    account?: string;
}
export default injectIntl((props: InjectedIntlProps & IDatabaseSelectProps) => {

    const [databases, setDatabases] = React.useState<IDatabaseBase[]>([]);
    const [isLoadingDatabases, setIsLoadingDatabases] = React.useState<boolean>(false);
    const [selectedDatabaseName, setSelectedDatabaseName] = React.useState<string | null>(null);

    const messages = defineMessages({
        serverError: {
            id: 'database.select.err',
            defaultMessage: 'There was an error contacting the server. Please reload the page and try again.'
        }
    });

    useEffect(() => {
        loadData();
    }, [props.account]);

    useEffect(() => {
        if (selectedDatabaseName && props.selectedDatabaseName === null) setSelectedDatabaseName(null);
    }, [props])

    const handleDatabaseChange = (e: any) => {
        setSelectedDatabaseName(e.currentTarget.value)
        props.onChange(e.currentTarget.value)
    }

    const loadData = async () => {
        try {
            setIsLoadingDatabases(true);
            const dbs: IDatabaseBase[] = [];
            let result = await getDatabases(undefined, props.account, 'account');
            if (result.success && Array.isArray(result.databases)) dbs.push(...result.databases);
            if (!props.hidePartnerDatabases) {
                result = await getDatabases(undefined, props.account, 'partnered');
                if (result.success && Array.isArray(result.databases)) dbs.push(...result.databases);
            }
            setIsLoadingDatabases(false);
            setDatabases(dbs);
        } catch (ex) {
            console.error(ex);
            alert(props.intl.formatMessage(messages.serverError));
        }
    };

    const renderCreateLink = () => {
        if (!props.canCreate || !props.currentModalId) return null;
        return (
            <Link to={`${DATABASE_CREATE_PATH}`} className="primary py-2 px-4" onClick={() => {
                // @ts-ignore
                $(`#${currentModalId}`).modal('hide');
            }}>
                <FormattedMessage id="dash.db.select.dbcta" defaultMessage="Create New Database" />
            </Link>
        )
    }

    const renderEmptyDatabaseState = () => {
        if (props.canCreate) {
            return (
                <div className="text-center my-5">
                    <i className="fas fa-rocket text-light-gray my-5" style={{ fontSize: 84 }} />
                    <br />
                    <div className="text-muted mb-5">{props.noDatabasesMessage}</div>
                    {renderCreateLink()}
                </div>
            );
        } else {
            return null;
        }
    };

    if (isLoadingDatabases) {
        return <PropagateLoader size={15} loading={isLoadingDatabases} color="#29447b" />
    } else if (props.account && (!databases || !Array.isArray(databases) || !databases.length)) {
        return <h5>This account does not yet have any databases for you to join. Please try again later.</h5>
    } else if (!databases || !Array.isArray(databases) || !databases.length) {
        return renderEmptyDatabaseState();
    }

    return (
        <div className="input-group">
            <select className={`form-control custom-select ${props.errorMessage ? 'is-invalid' : ''}`} value={selectedDatabaseName || ''} onChange={handleDatabaseChange}>
                <option value="">{props.defaultMessage}</option>
                {databases.map(db => {
                    const accountName = db.accountName || (typeof db?.account === 'string' ? db?.account : db?.account?.title)
                    return (<option key={`${db.created}-${db.name}-db-select`} value={db.name}>{db.title} {accountName ? `(${accountName})` : ''}</option>)
                })}
            </select>
            <div className="invalid-feedback">
                {props.errorMessage}
            </div>
        </div>
    )

});



// WEBPACK FOOTER //
// ./src/client/shared/DatabaseSelect.tsx